import { render, staticRenderFns } from "./ContabilitaSoggettoListComponent.vue?vue&type=template&id=6879d4a0"
import script from "./ContabilitaSoggettoListComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaSoggettoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports